// src/components/tour/tours/adminManager.jsx
//
// Admin Manager tour (superadmins only - the route redirects everyone
// else). ctx is registered in AdminManager.jsx.

import React from 'react';
import { replayStep } from './common';

const RoleChip = ({ superadmin }) => (
    <span className={'cm-role-chip ' + (superadmin ? 'cm-admin' : 'cm-operator')}>
        {superadmin ? 'SUPERADMIN' : 'ADMIN'}
    </span>
);

const StatusChip = ({ a }) =>
    !a.is_verified ? <span className="cm-status-chip cm-pending">PENDING</span>
    : a.is_active ? <span className="cm-status-chip cm-active">ACTIVE</span>
    : <span className="cm-status-chip cm-inactive">INACTIVE</span>;

export function getAdminManagerSteps(ctx, env) {
    const { admins = [], tourAdmin, openMobileAddPanel, closeMobileAddPanel } = ctx;
    const { isMobile } = env;
    const supers = admins.filter((a) => a.role === 'superadmin').length;

    const formText = (
        <>
            <p>Username, email and role. The new admin gets a setup email to choose their password.</p>
            <p>
                <RoleChip /> can use every admin page except this one.{' '}
                <RoleChip superadmin /> can also manage internal admins here.
            </p>
        </>
    );

    return [
        {
            target: null,
            title: 'Welcome to Admin Manager',
            content: (
                <p>
                    Your own team's accounts (internal admins, not clients):{' '}
                    <span className="pt-data">{admins.length}</span> admin{admins.length === 1 ? '' : 's'}, of which{' '}
                    <span className="pt-data">{supers}</span> superadmin{supers === 1 ? '' : 's'}.
                    Only superadmins can open this page.
                </p>
            ),
        },

        { layout: 'desktop', target: '[data-tour="am-add"]', title: 'Create an admin', content: formText },
        {
            layout: 'mobile',
            target: '[data-tour="am-add-toggle"]',
            onEnter: closeMobileAddPanel,
            title: 'Create an admin',
            content: <p>Tap <b>+ ADD ADMIN</b> to open the form.</p>,
        },
        {
            layout: 'mobile',
            target: '[data-tour="am-add-form"]',
            onEnter: openMobileAddPanel,
            title: 'The form',
            content: formText,
        },

        {
            target: '[data-tour="am-admin"]',
            onEnter: isMobile ? closeMobileAddPanel : undefined,
            title: tourAdmin ? tourAdmin.username : 'An admin',
            content: tourAdmin ? (
                <>
                    <p>
                        Role <RoleChip superadmin={tourAdmin.role === 'superadmin'} />, status <StatusChip a={tourAdmin} />
                        {!isMobile && ', and when they last logged in'}.
                    </p>
                    <p>
                        <span className="cm-status-chip cm-pending">PENDING</span> means they haven't finished the setup email yet.
                    </p>
                </>
            ) : null,
        },

        {
            target: '[data-tour="am-admin-actions"]',
            title: 'Admin actions',
            content: (
                <>
                    <p>
                        <b>RESET PW</b> emails a password reset link. <b>PROMOTE / DEMOTE</b> switches between admin
                        and superadmin. <b>NOTIF ON/OFF</b> controls push notifications on their phone.
                    </p>
                    <p>
                        <b>DEACTIVATE</b> blocks sign-in without deleting the account; <b>DELETE</b> removes it.
                        You can't demote, deactivate or delete your own account.
                    </p>
                </>
            ),
        },

        replayStep,
    ];
}
